define([
    'lodash'
], function (_) {
    'use strict';

    function isTopLevelStyle(style) {
        return style.type !== 'ComponentStyle' && !_.startsWith(style.id, 'style-');
    }

    return {
        serialize: ({pagesData}) => {
            const {theme_data: themeData} = pagesData.masterPage.data;
            const colors = themeData.THEME_DATA.color;
            const fonts = themeData.THEME_DATA.font;
            const theme = _.omit(themeData.THEME_DATA, 'color', 'font');
            _.unset(pagesData.masterPage.data.theme_data, 'THEME_DATA');


            const topLevelStyles = _.pickBy(themeData, isTopLevelStyle);

            _.forEach(topLevelStyles, (style, styleId) => {
                _.unset(pagesData.masterPage.data.theme_data, styleId);
            });

            return {
                styles: {
                    colors,
                    fonts,
                    theme,
                    topLevelStyles
                }
            };
        },
        deserialize: payload => {
            const {styles} = payload;
            return {
                pagesData: {
                    masterPage: {
                        data: {
                            theme_data: Object.assign({
                                THEME_DATA: Object.assign({
                                    color: styles.colors,
                                    font: styles.fonts
                                }, styles.theme)},
                            styles.topLevelStyles
                            )
                        }
                    }
                }
            };
        },
        getEncryptedPaths: () => ['styles.colors', 'styles.fonts', 'styles.theme', 'styles.topLevelStyles']
    };
});
